import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-status-message',
  standalone: true,
  templateUrl: './status-message.component.html'
})
export class StatusMessageComponent {
  @Input() title = 'Permission Denied';
  @Input() message = 'You do not have permission to access this feature. Please contact your system administrator to review and provide access.';
  @Input() iconClass = 'fa-regular fa-circle-xmark text-8xl text-red-400';
}
